import { createDatabaseService } from '../database/DatabaseService';

type UploadFileType = {
  file: File;
  bucket: string;
  supabase: any;
};

type DownloadFileType = {
  filename: string;
  bucket: string;
  supabase: any;
};

export const uploadFile = async (input: UploadFileType) => {
  const { file, bucket, supabase } = input;
  const db = createDatabaseService(supabase);
  return await db.storage.uploadFile(file, bucket);
};

export const downloadFile = async (input: DownloadFileType) => {
  const { filename, bucket, supabase } = input;
  const db = createDatabaseService(supabase);
  const { data, error } = await db.storage.downloadFile(filename, bucket);
  if (error) {
    console.error('Error downloading file:', error.message || error);
  } else if (data) {
    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
